import React, { useEffect } from "react";
import TopNav from "../TopNav";

export default function TermsOfService() {
  // scroll to the top
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);

  return (
    <div>
      <TopNav />
      <div className="pageContainer max-width-700">
        <h3>Terms of Service</h3>
        <p>Effective Date: December, 2024.</p>

        <h4>1. Acceptance of Terms</h4>
        <p>
          By using the App, you agree to comply with these Terms and any
          applicable laws. If you do not agree, do not use the App.
        </p>

        <h4>2. License</h4>
        <p>
          We grant you a limited, non-exclusive, non-transferable license to use
          the App for personal purposes. You may not copy, modify, distribute,
          or sell any part of the App.
        </p>

        <h4>3. User Responsibilities</h4>
        <p>You are responsible for:</p>
        <ul>
          <li>Ensuring the App is used in compliance with applicable laws.</li>
          <li>Safeguarding your device and access credentials.</li>
          <li>
            Not using the App to violate others’ rights or for any illegal
            purposes.
          </li>
        </ul>

        <h4>4. Privacy</h4>
        <p>
          Our Privacy Policy explains how we handle your data. By using the App,
          you consent to our data practices outlined in the Privacy Policy.
        </p>

        <h4>5. Payments</h4>
        <p>
          If you make a purchase, all payment processing is handled securely by
          Stripe. We are not responsible for issues arising from payment
          processing.
        </p>

        <h4>6. Disclaimers</h4>
        <p>
          The App is provided "as is" without warranties of any kind, including
          but not limited to fitness for a particular purpose. We do not
          guarantee uninterrupted or error-free operation.
        </p>

        <h4>7. Limitation of Liability</h4>
        <p>
          To the maximum extent permitted by law, we are not liable for any
          damages arising from your use of the App.
        </p>

        <h4>8. Changes to These Terms</h4>
        <p>
          We reserve the right to update these Terms at any time. Continued use
          of the App constitutes your acceptance of the updated Terms.
        </p>

        <h4>9. Contact Us</h4>
        <p>
          If you have questions about these Terms, please contact us at [Your
          Contact Email].
        </p>
      </div>
    </div>
  );
}
